module.exports = __webpack_public_path__ + "static/media/savesticon.0dd85dcb.svg";